import React, { Component } from 'react'
import { toast } from 'react-toastify'
import {motion} from 'framer-motion'
import $ from 'jquery'
// component
import Toaster from '../Toaster/Toaster'
import agent from '../../api/Api'
import { trackPageView, trackTimeSpent, trackFormConfusion } from '../../utils/Analytics'
import config from '../../config/config'
// css
import './Help.css'

const FIELD_NAME_MAP = {
  email: 'email',
  gender: 'gender',
  genderOthers: 'other gender',
  age: 'age',
  message: 'message'
}

class Help extends Component {
  constructor (props) {
    super(props)
    this.state = {
      email: '',
      gender: '',
      genderOthers: '',
      age: '',
      message: '',
      userInfo: {},
      errorCount: {
        email: 0,
        gender: 0,
        genderOthers: 0,
        age: 0,
        message: 0
      }
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.fieldTimers = {};
  }

  handleInputChange (event) {
    const { name, value } = event.target
    const analyticsName = FIELD_NAME_MAP[name] || name;
    if (name === 'age') {
      let re = /^[0-9\b]+$/
      if (re.test(value) || value === '') this.setState({ [name]: value })
    } else {
      this.setState({ [name]: value })
    }
    if (value.length > 0) {
      $('#' + name).css({ border: '1px solid #ddd' })
    } else {
      $('#' + name).css({ border: '1px solid red' })
      this.setState(prev => ({
        errorCount: {
          ...prev.errorCount,
          [name]: (prev.errorCount[name] || 0) + 1
        }
      }), () => {
        if (this.state.errorCount[name] >= config.ERROR_COUNT) {
          trackFormConfusion('Help', analyticsName);
        }
      });
    }
  }

  handleFocus = (field) => {
    this.fieldTimers[field] = Date.now();
  };

  handleBlur = (field) => {
    if (this.fieldTimers[field]) {
      const duration = (Date.now() - this.fieldTimers[field]) / 1000;
      if (duration > config.FOCUS_TIME) {
        const analyticsName = FIELD_NAME_MAP[field] || field;
        trackFormConfusion('Help', analyticsName, duration);
      }
      delete this.fieldTimers[field];
    }
  };

  handleSubmit () {
    $('#loader').fadeIn()
    let param = {
      email: this.state.email,
      gender: this.state.gender,
      age: this.state.age,
      message: this.state.message
    }

    let count = 0
    for (var key in param) {
      if (param[key]) {
        $('#' + key).css({ border: '1px solid #ddd' })
        count += 1
      } else {
        $('#' + key).css({ border: '1px solid red' })
        const currentKey = key;
        const analyticsName = FIELD_NAME_MAP[currentKey] || currentKey;
        this.setState(prev => ({
          errorCount: {
            ...prev.errorCount,
            [currentKey]: (prev.errorCount[currentKey] || 0) + 1
          }
        }), () => {
          if (this.state.errorCount[currentKey] >= config.ERROR_COUNT) {
            trackFormConfusion('Help', analyticsName);
          }
        });
      }
    }

    if (param.gender === 'Other') {
      if (this.state.genderOthers) {
        param.gender = this.state.genderOthers
        $('#genderOthers').css({ border: '1px solid #ddd' })
      } else {
        count = 0
        $('#genderOthers').css({ border: '1px solid red' })
         this.setState(prev => ({
          errorCount: {
            ...prev.errorCount,
            genderOthers: (prev.errorCount['genderOthers'] || 0) + 1
          }
        }), () => {
          if (this.state.errorCount['genderOthers'] >= config.ERROR_COUNT) {
            trackFormConfusion('Help', 'other gender');
          }
        });
      }
    }

    console.log(count)
    if (count === 4) {
      agent.APILIST.teacherSignin('/teacher/submitHelp', param)
        .then(res => {
          if (res.status === 'SUCCESS') {
            $('#loader').fadeOut()
            this.props.hideOverlay()
            toast.dismiss()
            toast(<Toaster title='Help' content={res.message} status='success' />)
            setTimeout(function () { toast.dismiss() }, 3000)
          }
        })
        .catch(err => {
          let res = JSON.parse(err.response.text)
          toast.dismiss()
          toast(<Toaster title='Help' content={res.message} status='error' />)
          setTimeout(function () { toast.dismiss() }, 3000)
          $('#loader').fadeOut()
        })
    } else {
      window.scrollTo(0, 0)
      $('#loader').fadeOut()
    }
  }

  componentDidMount () {
    trackPageView('/help');
    this.startTime = Date.now();
    this.currentPath = window.location.href;
    var loginCheck = JSON.parse(localStorage.getItem('userInfo'))
    // console.log('loginCheck', loginCheck)
    if (loginCheck) {
      this.setState({ userInfo: loginCheck })
    }
  }

  componentWillUnmount() {
      trackTimeSpent('/help', this.currentPath, this.startTime);
  }

  render () {
    return (
      <div id='help-form'>
        <div className='help-outer-blk noselect'>
          <div className='help-blk'>
            <div className='title-blk'>
              <p className='help-title'>We are here to help!</p>
            </div>
            <div className='vertical-field-group'>
              <div className='label-input'>
                <label>email*</label>
                <br />
                <input type='text' autoFocus name='email' id='email' maxLength='25' placeholder='Enter your email' value={this.state.email} onChange={this.handleInputChange} onFocus={()=>this.handleFocus('email')} onBlur={() => this.handleBlur('email')} />
              </div>
            </div>
            <div className='vertical-field-group'>
              <div className='label-input'>
                <label>gender*</label>
                <br />
                <select name='gender' id='gender' value={this.state.gender} onChange={this.handleInputChange} onFocus={()=>this.handleFocus('gender')} onBlur={() => this.handleBlur('gender')} >
                  <option value=''>Select one...</option>
                  <option value='Male'>Male</option>
                  <option value='Female'>Female</option>
                  <option value='Other'>Other</option>                  
                  <option value='Prefer not to answer'>Prefer not to answer</option>
                </select>
              </div>
            </div>
            {this.state.gender === 'Other'
              ? (<motion.div initial={{opacity:0}} animate={{opacity:1}} transition={{duration:0.3}} >
                <div className='vertical-field-group'>
                  <div className='label-input'>
                    <input type='text' name='genderOthers' id='genderOthers' maxLength='25' placeholder='Enter your gender' value={this.state.genderOthers} onChange={this.handleInputChange} onFocus={()=>this.handleFocus('genderOthers')} onBlur={() => this.handleBlur('genderOthers')} />
                  </div>
                </div>
              </motion.div>)
              : ''
            }
            <div className='vertical-field-group'>
              <div className='label-input'>
                <label>age*</label>
                <br />
                <input type='text' name='age' id='age' maxLength='25' placeholder='Enter your age' value={this.state.age} onChange={this.handleInputChange} onFocus={()=>this.handleFocus('age')} onBlur={() => this.handleBlur('age')} />
              </div>
            </div>
            <div className='vertical-field-group'>
              <div className='label-input'>
                <label>message*</label>
                <br />
                <textarea type='text' name='message' id='message' maxLength='255' rows='4' placeholder='Enter your message' value={this.state.message} onChange={this.handleInputChange} onFocus={()=>this.handleFocus('message')} onBlur={() => this.handleBlur('message')} />
              </div>
            </div>
            <div className='bottom-section'>
              <div className='cancel-blk' onClick={this.props.hideOverlay}>
                <p className='cancel-btn'>Cancel</p>
              </div>
              <div className='submit-blk' onClick={this.handleSubmit}>
                <p className='submit-btn'>submit</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    )
  }
}

export default Help
